import { render } from "./otherPages.vue?vue&type=template&id=43bd4e8a&scoped=true"
import script from "./otherPages.vue?vue&type=script&lang=js"
export * from "./otherPages.vue?vue&type=script&lang=js"

import "./otherPages.vue?vue&type=style&index=0&id=43bd4e8a&scoped=true&lang=css"

import exportComponent from "/home/wido/Documents/Project/SS-GreedGreed/ss-web-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43bd4e8a"]])

export default __exports__